import React, { useEffect, useState, useCallback, useRef } from 'react'
import { usePaginationImportantAnnouncementMutation } from '../../../app/services/importantAnnouncementService'
import EastIcon from '@mui/icons-material/East'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import './spotlight.css'
import { usePaginationSpotLightMutation } from '../../../app/services/spotlightService'
import { Button } from '@material-ui/core'
import { Modal, Box, Typography, IconButton, Container, Divider } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'
import { Link } from 'react-router-dom'
import Carousel from 'react-multi-carousel'

const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    placeItems: "center",
    // width:'700px',
    maxWidth: "40%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "5px",
    padding: 4,
    height: "75vh",
    zIndex: "9999999",
};
// custom circular arrow buttons
const CustomButtonGroup = ({ next, previous }) => {
    return (
        <div className="d-flex align-items-center justify-content-end me-md-3 me-0 w-100" style={{ position: 'absolute', right: '-3%', top: '-5%', transform: 'translateY(-50%)' }}>
            <p className="viewAllEvents Spot-light-header Spot-light-header-border title-font alata-medium mb-0">
                <Link to="/view-spot-light" style={{ textDecoration: 'none', color: '#ffff' }}>View All</Link>
                <EastIcon />
                <ArrowBackIosIcon
                    onClick={previous}
                    className={`ms-1 arrowConfig-sportlight`}
                />

                <ArrowForwardIosIcon
                    onClick={next}
                    className={`ms-1 arrowConfig-sportlight`}
                />
            </p>
        </div>
    );
};
// responsive breakpoints
const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 576 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 576, min: 0 },
        items: 1,
    },
};

function SpotLight() {
    const [page, setPage] = useState(1)
    const [announcements, setAnnouncements] = useState([])
    const [spotlights, setSpotlights] = useState([])
    const [paginationAnnouncement] = usePaginationImportantAnnouncementMutation()
    const [PaginationSpotLight] = usePaginationSpotLightMutation()
    const rowsPerPage = 7
    const [loading, setLoading] = useState(false) // Loading state to prevent multiple API requests
    const [open, setOpen] = useState(false);
    const [selectedSpotlight, setSelectedSpotlight] = useState(null);
    const containerRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [totalPage, setTotalPage] = useState(null)

    const fetchSpotLight = useCallback(async () => {
        const data = {
            page: 1,
            itemsPerPage: '',
            role: "", // Ensure role is correctly assigned if needed
        };
        try {
            const res = await PaginationSpotLight(data);
            if (res?.data?.status) {
                setSpotlights(res?.data?.data?.spotLightDetails);
            } else {
                console.error("Failed to fetch spotlight data.");
            }
        } catch (error) {
            console.error("Error fetching spotlight data:", error);
        }
    }, [PaginationSpotLight]); // Remove PaginationSpotLight from dependencies

    // Trigger fetch on dependencies change
    useEffect(() => {
        fetchSpotLight();
    }, [fetchSpotLight]);


    const fetchAnnouncements = useCallback(async () => {
        const data = {
            page: page,
            itemsPerPage: rowsPerPage,
            role: "",
            isExpired: 1,
        };
        try {
            const res = await paginationAnnouncement(data);
            if (res?.data?.status) {
                const totalCount = res?.data?.data?.totalCount || 0;
                const totalPage = Math.ceil(totalCount / rowsPerPage);
                setTotalPage(totalPage);
                // Only append new announcements if there are new ones
                if (page > 1) {
                    setAnnouncements(prev => [...prev, ...res?.data?.data?.newAnnouncementDetails]);
                }
                else {
                    setAnnouncements(res?.data?.data?.newAnnouncementDetails)
                    // Reset scrollTop when loading the first page
                    requestAnimationFrame(() => {
                        if (containerRef.current) {
                            containerRef.current.scrollTo({
                                top: 0,
                                behavior: "auto", // or "smooth" if you want animated reset
                            });
                        }
                    });
                }

            }
        } catch (error) {
            console.error("Error fetching announcements:", error);
        } finally {
            setLoading(false); // Reset loading state
        }
    }, [page, rowsPerPage, paginationAnnouncement]);

    // UseEffect to fetch data when the component first loads

    useEffect(() => {
        fetchAnnouncements();
    }, [fetchAnnouncements]);

    // Handle scroll event and increase page number when bottom is reached
    const handleScroll = useCallback((e) => {
        const el = e.target;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
            setPage((prev) => (prev <= totalPage ? prev + 1 : 1));
        }
    }, [totalPage]);


    // Add scroll event listener to announcement container on mount
    // Add scroll event listener once on mount
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.addEventListener("scroll", handleScroll);

        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);

    const handleOpen = (spotlight) => {
        setSelectedSpotlight(spotlight);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        let scrollInterval;

        if (!isPaused) {
            scrollInterval = setInterval(() => {
                if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                    // Smooth scroll back to top
                    container.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                } else {
                    container.scrollTop += 1; // step size
                }
            }, 50); // adjust for speed
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]);


    return (
        ((announcements && announcements.length < 0) && (spotlights && spotlights.length < 0)) ? <></> :
            <div className="spotlightHomepage-background-color">
                <div className='p-md-5 p-3 overallPadding'>
                    <div className="row justify-content-center align-items-center g-5">
                        <div className="col-lg-7 px-lg-5 px-4 mt-5 h-100">
                            {/* Header row */}
                            <div className="d-flex justify-content-between">
                                <h2 className="custom-header title-font" style={{ color: "#ffff" }}>Spotlights</h2>
                            </div>
                            <div className={`row justify-content-center position-relative h-100 ${(spotlights && spotlights.length === 0) ? 'px-2' : ''}`}>
                                {spotlights && spotlights.length !== 0 ?
                                    <Carousel
                                        additionalTransfrom={0}
                                        arrows={false}
                                        autoPlay
                                        autoPlaySpeed={3000}
                                        centerMode={false}
                                        containerClass="container-with-dots"
                                        draggable
                                        focusOnSelect={false}
                                        infinite
                                        minimumTouchDrag={80}
                                        pauseOnHover
                                        renderArrowsWhenDisabled={false}
                                        customButtonGroup={<CustomButtonGroup />}
                                        renderButtonGroupOutside={true}
                                        renderDotsOutside={false}
                                        responsive={responsive}
                                        rewind={false}
                                        rewindWithAnimation={false}
                                        rtl={false}
                                        shouldResetAutoplay
                                        showDots={false}
                                        slidesToSlide={1}
                                    >
                                        {spotlights
                                            .map((spotlight) => (
                                                <div className="bg-white h-100 d-flex justify-content-between flex-column pe-2 me-3">
                                                    <div className="d-flex justify-content-center align-items-center py-3">
                                                        <img
                                                            src={`${spotlight?.image}?t=${new Date().getTime()}`}
                                                            alt={spotlight._id}
                                                            className="aspect4"
                                                            width={120}
                                                            height={120}
                                                        />
                                                    </div>
                                                    <div className="d-flex justify-content-center align-items-center backgroud-sportlight-Text mb-3">
                                                        <h6 className="fw-bold poppins-semibold menus-green-color text-center text-capitalize px-3 title-font">
                                                            {spotlight?.heading}
                                                        </h6>
                                                    </div>
                                                    <div className="pb-2">
                                                        <p className="spotlight-content poppins-light fs-6 justified px-3 content-font">
                                                            {spotlight?.content.length > 150
                                                                ? spotlight?.content.slice(0, 150) + "...."
                                                                : spotlight?.content}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-center align-items-end mb-3">
                                                        <Button
                                                            className="spot-light-button dynamicButton content-font"
                                                            style={{
                                                                color: "#ffffff",
                                                                borderRadius: 0,
                                                                textTransform: "none",
                                                            }}
                                                            variant="contained"
                                                            onClick={() => handleOpen(spotlight)}
                                                        >
                                                            Know More
                                                        </Button>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </Carousel>
                                    : (
                                        <div
                                            className="shadow-none Announcement-home-page-card bg-white"
                                        >
                                            <div className='content-font fw-bold text-center fs-5'>Will Be Added Shortly</div>
                                        </div>
                                    )
                                }
                            </div>

                        </div>
                        <div className="col-lg-5">
                            <div className="d-flex justify-content-between">
                                <h2 className="custom-header title-font" style={{ color: "#ffff" }}>Announcements</h2>
                            </div>
                            <div ref={containerRef}
                                id="announcement-container"
                                onMouseEnter={() => setIsPaused(true)}   // Pause when hover
                                onMouseLeave={() => setIsPaused(false)}  // Resume when leave
                                className="shadow-none Announcement-home-page-card overflow-y-scroll bg-white"
                            >
                                {announcements.length > 0 ? (
                                    announcements.map((announcement, i) => {
                                        // Strip HTML tags to get plain text for truncation
                                        const plainText = (announcement.text || "")
                                            .replace(/<[^>]*>/g, "")
                                            .replace(/&nbsp;/g, " ")
                                            .replace(/&amp;/g, "&")
                                            .replace(/&lt;/g, "<")
                                            .replace(/&gt;/g, ">")
                                            .trim();
                                        const MAX_CHARS = 300;
                                        const isTruncated = plainText.length > MAX_CHARS;
                                        const displayText = isTruncated
                                            ? plainText.slice(0, MAX_CHARS) + "..."
                                            : plainText;

                                        const fileCount = Array.isArray(announcement.files)
                                            ? announcement.files.length
                                            : announcement.fileUrl ? 1 : 0;

                                        return (
                                            <div key={i} className="announcements-card-homepage-text py-2 content-font">
                                                <ul>
                                                    <li className="annocement-text poppins-regular lh-lg">
                                                        <span
                                                            style={{
                                                                color: "#611f1e",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word",
                                                                overflowWrap: "break-word",
                                                                whiteSpace: "pre-wrap",
                                                                textTransform: "capitalize",
                                                                display: "block",
                                                                lineHeight: "1.5!important",
                                                            }}
                                                        >
                                                            {displayText}
                                                        </span>
                                                        {/* File attachment badge */}
                                                        {fileCount > 0 && (
                                                            <span
                                                                style={{
                                                                    display: "inline-block",
                                                                    fontSize: "0.78rem",
                                                                    color: "#611f1e",
                                                                    fontWeight: 600,
                                                                    marginTop: "4px",
                                                                }}
                                                            >
                                                                📎 {fileCount} attachment{fileCount > 1 ? "s" : ""}
                                                            </span>
                                                        )}
                                                        {/* Read more link */}
                                                        {(isTruncated || fileCount > 0) && (
                                                            <Link
                                                                to={`/viewAnnouncement/${announcement._id}`}
                                                                style={{
                                                                    display: "block",
                                                                    marginTop: "4px",
                                                                    color: "#1a6b45",
                                                                    fontWeight: 600,
                                                                    fontSize: "0.85rem",
                                                                    textDecoration: "none",
                                                                }}
                                                            >
                                                                Read more →
                                                            </Link>
                                                        )}
                                                    </li>
                                                </ul>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className='content-font fw-bold text-center fs-5'>Will Be Added Shortly</div>
                                )}
                                {loading && <div>Loading...</div>}
                            </div>
                        </div>
                    </div >
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box
                                sx={style1}
                                className="d-flex align-items-center flex-column gap-3 overflow-x-hidden"
                            >
                                <Container maxWidth={false} sx={{ px: 3 }}>
                                    <Box className="d-flex justify-content-between py-2">

                                        <Typography className="alata-semibold" variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }} >
                                            View Spotlights
                                        </Typography>
                                        <IconButton onClick={handleClose} aria-label="Close">
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>

                                    {/* Centered Divider */}
                                    <Box display="flex" justifyContent="center" width="100%">
                                        <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                    </Box>

                                    <div className="d-flex justify-content-center">
                                        <h2
                                            className="alata-medium fs-5 text-center py-2"
                                            style={{ color: "#611f1e" }}
                                        >
                                            {selectedSpotlight?.heading}
                                        </h2>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div >
                                            <img
                                                src={selectedSpotlight?.image}
                                                className="img-fluid"
                                                alt="img"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-justify" >
                                        <p className="alata-regular spotlight-text-justify p-0 my-3" >
                                            {selectedSpotlight?.content}
                                        </p>
                                    </div>
                                </Container>
                            </Box>
                        </Modal>
                    </Modal>
                </div >
            </div >
    )
}

export default SpotLight
